import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export const AuditService = {
  list: (params?: { page?: number; limit?: number; action?: string }) => {
    const url = REQUEST_URL.AUDIT_LOGS;
    return RequestUtil.get({
      url,
      query: params || {},
    });
  },
};
